// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { focusStyles } from "@toolkit/Themes/common/mixins/common";
import { css } from "styled-components";

export const productCompareRemoveButtonStyles = () => css`
    ${buttonResetProps.css}
    /* Bunzl custom code, only highlight on focus visible */
    ${focusStyles(true)}
    transition: ${transitionHoverStyles("color")};

    &:hover {
        color: ${getColor("primary")};
    }
`;
